export function initGalleryModal() {
  let currentImageIndex = 0;
  const galleryItems = document.querySelectorAll(".single-image");
  const totalImages = galleryItems.length;

  const overlay = document.querySelector(".gallery__overlay");
  const fullImage = document.querySelector(".gallery__full-image");
  const closeBtn = document.querySelector(".gallery__close");
  const prevBtn = document.querySelector(".gallery__prev");
  const nextBtn = document.querySelector(".gallery__next");

  // Proceed only if all core elements exist
  if (
    !overlay ||
    !fullImage ||
    !closeBtn ||
    !prevBtn ||
    !nextBtn ||
    totalImages === 0
  ) {
    return; // Exit if not on the page that has gallery
  }

  function updateModalContent() {
    const currentImage = galleryItems[currentImageIndex].querySelector("img");
    if (currentImage) {
      fullImage.src = currentImage.src;
      fullImage.alt = currentImage.alt || "Gallery image";
    }
  }

  galleryItems.forEach((item, index) => {
    item.addEventListener("click", () => {
      currentImageIndex = index;
      updateModalContent();
      overlay.style.display = "flex";
      overlay.classList.add("visible");
    });
  });

  prevBtn.addEventListener("click", (e) => {
    e.preventDefault();
    currentImageIndex = (currentImageIndex - 1 + totalImages) % totalImages;
    updateModalContent();
  });

  nextBtn.addEventListener("click", () => {
    currentImageIndex = (currentImageIndex + 1) % totalImages;
    updateModalContent();
  });

  closeBtn.addEventListener("click", () => {
    overlay.classList.remove("visible");
    setTimeout(() => {
      overlay.style.display = "none";
    }, 200);
  });

  document.addEventListener("keydown", (e) => {
    if (overlay.classList.contains("visible")) {
      if (e.key === "ArrowLeft") {
        currentImageIndex = (currentImageIndex - 1 + totalImages) % totalImages;
        updateModalContent();
      } else if (e.key === "ArrowRight") {
        currentImageIndex = (currentImageIndex + 1) % totalImages;
        updateModalContent();
      } else if (e.key === "Escape") {
        overlay.classList.remove("visible");
        setTimeout(() => {
          overlay.style.display = "none";
        }, 200);
      }
    }
  });
}

// Check if we are in an ACF block preview environment and hook into its render action.
if (window.acf) {
  window.acf.addAction(
    "render_block_preview/type=gallery-page",
    initGalleryModal
  );
} else {
  document.addEventListener("DOMContentLoaded", function () {
    initGalleryModal();
  });
}
